import { FC, useEffect } from "react"

import {
  AppCTABanner,
} from '@/components'

import { useApp } from "@assets/hooks/useApp"
import { useMediaQuery } from 'react-responsive'
import { pdcStore } from "@assets/store/pdcStore";

/* trigger PWA install process */
export const Download: FC = () => {

  const [_, action] = useApp('banner')
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })

  const TopBarAppCTAOpened = pdcStore.use.TopBarAppCTAOpened()

  useEffect(() => {
    const listener = () => {
      console.log('trigger PWA install process')
      action()
    }

    window.addEventListener('click', listener, { once: true })

    return () => {
      window.removeEventListener('click', listener)
    }
  }, [action])

  return (
    <div
      className="carousel-item banner_clickable"
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        paddingTop: TopBarAppCTAOpened ? isMobile ? '3rem' : '9rem' : '2rem',
      }}
    >
      <AppCTABanner />
    </div>
  );
};
